var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgB7879(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 544.032,
    height: 301.99,
    viewBox: "0 0 544.032 301.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVION",
    transform: "translate(-808.054 -166.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_41",
    "data-name": "Union 41",
    d: "M-15306.447-4989.375s17.22-12.136,29.556-28.482a129.391,129.391,0,0,1-36.3,1.38c-6.876-.815-8.771-3.165-8.771-3.165s-.092-23.6,0-23.652c5.876-5.3,21.7-5.011,32.551-4.561,9.391.392,24.152,3.518,27.959,4.353,15.463-27.525,38.407-69.5,38.407-69.5h52.563l-16.124,45.391-3.265,10.625h5.8s9.583,2.08,9.494,3.619-6.6,2.622-10.578,2.711c-3.96.092-6.638,0-6.664,0l-4.776,15.542v9.687h4.026s5.426,1.9,5.152,2.623-2.7,1.788-5.968,1.988c-1.783.109-2.726.173-3.211.208v31.235Z",
    transform: "translate(16298.652 5280)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M696.746,309.745s-4.095.166-11.781.437-22.876-.09-26.131,3.436,4.792,4.521,12.569,5.154,18.355.542,18.355.542c.587,0,1.026-.011,1.378-.039.176-.014.33-.032.471-.055h.008a3.8,3.8,0,0,0,.4-.087,21.487,21.487,0,0,0,6.556-2.888h0a27.192,27.192,0,0,0,4.569-3.15C704.858,311.576,696.746,309.745,696.746,309.745Z",
    transform: "translate(336.792 -65.014)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_42",
    "data-name": "Union 42",
    d: "M-15223.042-4989.375s-22.944-41.972-38.407-69.5c-3.807.834-18.568,3.961-27.959,4.353-10.852.45-26.675.738-32.551-4.561-.092-.054,0-23.653,0-23.653s1.9-2.35,8.771-3.165a129.41,129.41,0,0,1,36.3,1.38c-12.336-16.346-29.556-28.486-29.556-28.486h109.857v31.242c.485.034,1.428.1,3.211.206,3.269.2,5.7,1.265,5.968,1.988s-5.152,2.622-5.152,2.622h-4.026v9.687l4.776,15.543c.026,0,2.7-.092,6.664,0,3.976.088,10.485,1.173,10.578,2.711s-9.494,3.618-9.494,3.618h-5.8l3.265,10.625,16.124,45.386Z",
    transform: "translate(16298.652 5457.362)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M696.746,678.343s-4.095-.165-11.781-.437-22.876.09-26.131-3.436,4.792-4.521,12.569-5.154,18.355-.543,18.355-.543c.587,0,1.026.011,1.378.039.176.014.33.032.471.055h.008a3.742,3.742,0,0,1,.4.087,21.471,21.471,0,0,1,6.556,2.887h0a27.186,27.186,0,0,1,4.569,3.15C704.858,676.512,696.746,678.343,696.746,678.343Z",
    transform: "translate(336.792 -288.083)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M1163.364,431.611",
    transform: "translate(22.063 -140.679)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M544.257,485.7H410.439V441.137H544.257Zm-133.442-.377H543.881V441.514H410.816Z",
    transform: "translate(490.987 -146.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M452.548,489.779H410.591V452.572h42.145v.188c.078,36.83.019,36.889-.055,36.963l-.055.056Zm-41.581-.377h41.4c.049-2.147.016-24.388-.009-36.453H410.968Z",
    transform: "translate(490.851 -153.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M541.638,489.813l-.412-.411h.283c.079-2.113.025-24.624-.016-36.641v-.189h84.287v37.207H541.721Zm.221-.411H625.4V452.949H541.87c0,1.355.032,9.778.047,18.207C541.941,484.9,541.935,488.454,541.859,489.4Z",
    transform: "translate(409.532 -153.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M1133.146,485.7h-108.4V441.137h108.4Zm-108.025-.377h107.649V441.514H1025.121Z",
    transform: "translate(108.522 -146.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M1332.952,488.389h-21.379V455.7h21.379Zm-21-.377h20.626V456.081H1311.95Z",
    transform: "translate(-70.202 -155.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M1133.133,488.137h-108.41V452.452h108.41ZM1025.1,487.76h107.656V452.829H1025.1Z",
    transform: "translate(108.535 -153.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 0.377,
    height: 36.83,
    transform: "translate(972.166 299.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 0.377,
    height: 36.83,
    transform: "translate(923.158 299.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 0.377,
    height: 36.83,
    transform: "translate(993.17 299.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 0.377,
    height: 36.83,
    transform: "translate(1014.168 299.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 0.377,
    height: 35.308,
    transform: "translate(1176.396 299.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 0.377,
    height: 35.308,
    transform: "translate(1153.209 299.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 0.377,
    height: 35.308,
    transform: "translate(1198.654 299.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 0.377,
    height: 35.308,
    transform: "translate(1213.291 299.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 0.377,
    height: 35.308,
    transform: "translate(1226.707 299.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 42.613,
    height: 0.377,
    transform: "translate(1198.898 316.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M425.282,494.756c.865,0,1.314.449,1.314,1.134s-.449,1.134-1.314,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.713s-.279-.712-.849-.712h-.765Z",
    transform: "translate(482.492 -179.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M436.069,498.512V496.6c0-.475.005-.955.011-1.435h-.011c-.163.48-.337.955-.512,1.435l-.7,1.909H434.3l-.7-1.909c-.174-.481-.348-.955-.512-1.435h-.011c.005.48.011.96.011,1.435v1.909h-.475v-3.756h.781l.681,1.852c.169.475.337.966.5,1.441h.011c.158-.475.327-.966.5-1.441l.675-1.852h.786v3.756Z",
    transform: "translate(477.116 -179.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M448.106,495.905h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.123,1.509a.987.987,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.007,0-1.63-.739-1.63-1.952s.628-1.952,1.646-1.952A1.383,1.383,0,0,1,448.106,495.905Z",
    transform: "translate(469.419 -179.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M480.446,494.757c.865,0,1.314.449,1.314,1.134s-.448,1.134-1.314,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.713s-.279-.712-.849-.712h-.765Z",
    transform: "translate(448.141 -179.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M491.233,498.513V496.6c0-.475.005-.955.011-1.435h-.011c-.163.48-.337.955-.512,1.435l-.7,1.909h-.559l-.7-1.909c-.174-.481-.348-.955-.512-1.435h-.011c.005.48.011.96.011,1.435v1.909h-.475v-3.756h.781l.681,1.852c.169.475.337.966.5,1.441h.011c.158-.475.327-.966.5-1.441l.675-1.852h.786v3.756Z",
    transform: "translate(442.765 -179.979)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M503.27,495.906h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.123,1.509a.987.987,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.007,0-1.63-.739-1.63-1.952s.627-1.952,1.646-1.952A1.383,1.383,0,0,1,503.27,495.906Z",
    transform: "translate(435.067 -179.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M613.9,495.987c.865,0,1.313.448,1.313,1.134s-.448,1.134-1.313,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.712s-.279-.712-.849-.712H613.1Z",
    transform: "translate(365.034 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M624.691,499.743v-1.91c0-.475.005-.955.01-1.435h-.01c-.163.48-.338.955-.512,1.435l-.7,1.91h-.559l-.7-1.91c-.174-.48-.348-.955-.512-1.435h-.01c.005.48.01.96.01,1.435v1.91h-.475v-3.756h.781l.68,1.852c.169.475.338.965.5,1.44h.011c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(359.658 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M636.727,497.136h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.124,1.509a.986.986,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.008,0-1.63-.739-1.63-1.952s.628-1.952,1.646-1.952A1.383,1.383,0,0,1,636.727,497.136Z",
    transform: "translate(351.961 -180.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M558.835,495.987c.865,0,1.314.448,1.314,1.134s-.448,1.134-1.314,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.712s-.279-.712-.849-.712h-.765Z",
    transform: "translate(399.327 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M569.622,499.743v-1.91c0-.475.005-.955.01-1.435h-.01c-.164.48-.338.955-.512,1.435l-.7,1.91h-.559l-.7-1.91c-.174-.48-.348-.955-.512-1.435h-.01c.005.48.01.96.01,1.435v1.91h-.475v-3.756h.781l.68,1.852c.169.475.338.965.5,1.44h.011c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(393.951 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M581.659,497.136h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.14.57-1.14,1.509s.427,1.509,1.124,1.509a.986.986,0,0,0,1.023-.923h.506a1.424,1.424,0,0,1-1.53,1.366c-1.008,0-1.63-.739-1.63-1.952s.627-1.952,1.646-1.952A1.383,1.383,0,0,1,581.659,497.136Z",
    transform: "translate(386.254 -180.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M669.24,495.987c.865,0,1.313.448,1.313,1.134s-.448,1.134-1.313,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.85-.269.85-.712s-.279-.712-.85-.712h-.765Z",
    transform: "translate(330.576 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M680.027,499.743v-1.91c0-.475.005-.955.01-1.435h-.01c-.163.48-.338.955-.512,1.435l-.7,1.91h-.559l-.7-1.91c-.174-.48-.348-.955-.512-1.435h-.01c.005.48.01.96.01,1.435v1.91h-.474v-3.756h.781l.681,1.852c.169.475.338.965.5,1.44h.011c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(325.2 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M692.063,497.136h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.123,1.509a.987.987,0,0,0,1.024-.923h.506a1.424,1.424,0,0,1-1.53,1.366c-1.007,0-1.63-.739-1.63-1.952s.628-1.952,1.646-1.952A1.383,1.383,0,0,1,692.063,497.136Z",
    transform: "translate(317.503 -180.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M725.045,495.987c.865,0,1.314.448,1.314,1.134s-.448,1.134-1.314,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.712s-.279-.712-.849-.712h-.765Z",
    transform: "translate(295.825 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M735.832,499.743v-1.91c0-.475.006-.955.01-1.435h-.01c-.163.48-.337.955-.511,1.435l-.7,1.91h-.559l-.7-1.91c-.174-.48-.348-.955-.512-1.435h-.01c.005.48.01.96.01,1.435v1.91h-.475v-3.756h.781l.681,1.852c.169.475.338.965.5,1.44h.011c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(290.449 -180.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M747.869,497.136h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.123,1.509a.986.986,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.007,0-1.63-.739-1.63-1.952s.627-1.952,1.646-1.952A1.383,1.383,0,0,1,747.869,497.136Z",
    transform: "translate(282.752 -180.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M1096.387,495.867c.865,0,1.313.448,1.313,1.134s-.449,1.134-1.313,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.85-.269.85-.712s-.28-.712-.85-.712h-.765Z",
    transform: "translate(64.584 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M1107.174,499.623v-1.909c0-.475,0-.955.01-1.435h-.01c-.164.48-.338.955-.512,1.435l-.7,1.909h-.559l-.7-1.909c-.174-.48-.348-.955-.512-1.435h-.01c.006.48.01.96.01,1.435v1.909h-.474v-3.756h.781l.681,1.852c.169.475.337.965.5,1.44h.01c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(59.207 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M1119.21,497.016h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.124,1.509a.986.986,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.008,0-1.63-.739-1.63-1.952s.627-1.952,1.646-1.952A1.383,1.383,0,0,1,1119.21,497.016Z",
    transform: "translate(51.511 -180.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M1038.943,495.867c.865,0,1.314.448,1.314,1.134s-.449,1.134-1.314,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.765c.57,0,.849-.269.849-.712s-.28-.712-.849-.712h-.765Z",
    transform: "translate(100.355 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M1049.731,499.623v-1.909c0-.475.006-.955.011-1.435h-.011c-.163.48-.337.955-.511,1.435l-.7,1.909h-.559l-.7-1.909c-.174-.48-.348-.955-.512-1.435h-.01c0,.48.01.96.01,1.435v1.909h-.475v-3.756h.781l.681,1.852c.169.475.338.965.5,1.44h.011c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(94.979 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M1061.768,497.016h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.124,1.509a.986.986,0,0,0,1.023-.923h.507a1.424,1.424,0,0,1-1.53,1.366c-1.008,0-1.63-.739-1.63-1.952s.628-1.952,1.646-1.952A1.383,1.383,0,0,1,1061.768,497.016Z",
    transform: "translate(87.281 -180.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M1157.179,495.867c.865,0,1.313.448,1.313,1.134s-.449,1.134-1.313,1.134h-.8v1.488h-.485v-3.756Zm-.8,1.847h.764c.57,0,.85-.269.85-.712s-.28-.712-.85-.712h-.764Z",
    transform: "translate(26.729 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M1167.966,499.623v-1.909c0-.475,0-.955.01-1.435h-.01c-.164.48-.338.955-.512,1.435l-.7,1.909h-.559l-.7-1.909c-.174-.48-.348-.955-.512-1.435h-.01c.006.48.01.96.01,1.435v1.909h-.474v-3.756h.781l.681,1.852c.169.475.337.965.5,1.44h.01c.158-.475.327-.965.5-1.44l.675-1.852h.786v3.756Z",
    transform: "translate(21.354 -180.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M1180,497.016h-.5a.936.936,0,0,0-.992-.9c-.707,0-1.139.57-1.139,1.509s.427,1.509,1.124,1.509a.986.986,0,0,0,1.023-.923h.506a1.424,1.424,0,0,1-1.53,1.366c-1.008,0-1.63-.739-1.63-1.952s.627-1.952,1.646-1.952A1.383,1.383,0,0,1,1180,497.016Z",
    transform: "translate(13.656 -180.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M1204.364,477.1l-.411,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.544-1.53h-.01c-.18.522-.354,1.008-.544,1.53l-.126.343h1.345Z",
    transform: "translate(-2.879 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M1216.641,478.218h-.648l-1.63-1.846h-.011v1.846h-.486v-3.756h.486v1.694h.011l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-9.381 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M1222.823,474.894v1.187h1.825v.427h-1.825v1.277h1.994v.432h-2.479v-3.756h2.422v.432Z",
    transform: "translate(-14.662 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M1204.364,518.2l-.411,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.544-1.53h-.01c-.18.522-.354,1.008-.544,1.53l-.126.343h1.345Z",
    transform: "translate(-2.879 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M1216.641,519.316h-.648l-1.63-1.847h-.011v1.847h-.486V515.56h.486v1.694h.011l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-9.381 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M1222.823,515.993v1.187h1.825v.427h-1.825v1.276h1.994v.433h-2.479V515.56h2.422v.433Z",
    transform: "translate(-14.662 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M1243.608,477.1l-.412,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.544-1.53h-.01c-.179.522-.354,1.008-.544,1.53l-.126.343h1.345Z",
    transform: "translate(-27.317 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M1255.884,478.218h-.649l-1.63-1.846h-.01v1.846h-.486v-3.756h.486v1.694h.01l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-33.819 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M1262.066,474.894v1.187h1.825v.427h-1.825v1.277h1.994v.432h-2.479v-3.756H1264v.432Z",
    transform: "translate(-39.1 -167.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M1243.607,518.2l-.411,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.543-1.53h-.01c-.179.522-.353,1.008-.543,1.53l-.127.343h1.345Z",
    transform: "translate(-27.317 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M1255.884,519.316h-.649l-1.63-1.847h-.01v1.847h-.486V515.56h.486v1.694h.01l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-33.819 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M1262.064,515.993v1.187h1.825v.427h-1.825v1.276h1.994v.433h-2.479V515.56H1264v.433Z",
    transform: "translate(-39.1 -192.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M1281.281,476.846l-.411,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.544-1.53h-.01c-.18.522-.354,1.008-.543,1.53l-.127.343h1.345Z",
    transform: "translate(-50.777 -167.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M1293.558,477.965h-.648l-1.63-1.846h-.011v1.846h-.485v-3.756h.485V475.9h.011l1.514-1.694h.612L1291.764,476Z",
    transform: "translate(-57.278 -167.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M1299.74,474.641v1.187h1.825v.427h-1.825v1.277h1.994v.432h-2.479v-3.756h2.422v.432Z",
    transform: "translate(-62.56 -167.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M1281.281,517.945l-.411,1.119h-.517l1.424-3.756h.659l1.43,3.756h-.522l-.406-1.119Zm1.377-.77c-.19-.522-.364-1.008-.544-1.53h-.01c-.18.522-.354,1.007-.543,1.53l-.127.343h1.345Z",
    transform: "translate(-50.777 -192.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M1293.558,519.063h-.648l-1.63-1.846h-.011v1.846h-.485v-3.756h.485V517h.011l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-57.278 -192.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M1299.74,515.74v1.187h1.825v.427h-1.825v1.276h1.994v.433h-2.479v-3.756h2.422v.433Z",
    transform: "translate(-62.56 -192.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M1325.039,492.762c.865,0,1.266.385,1.266.955a.877.877,0,0,1-.623.876v.01a.852.852,0,0,1,.707.881c0,.628-.459,1.034-1.25,1.034h-1.325v-3.756Zm-.739,1.641h.7c.591,0,.823-.237.823-.617,0-.4-.237-.612-.8-.612h-.723Zm0,1.7h.77c.554,0,.818-.227.818-.649,0-.407-.258-.649-.886-.649h-.7Z",
    transform: "translate(-77.838 -178.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M1335.156,495.11a1.4,1.4,0,1,1-2.786,0v-2.348h.485V495.1c0,.7.338,1.05.908,1.05s.9-.348.9-1.05v-2.337h.491Z",
    transform: "translate(-83.172 -178.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M1344.729,496.086v.433h-2.406v-3.756h.486v3.324Z",
    transform: "translate(-89.376 -178.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M1352.953,496.518h-.649l-1.63-1.846h-.01v1.846h-.485v-3.756h.485v1.694h.01l1.514-1.694h.612l-1.641,1.789Z",
    transform: "translate(-94.272 -178.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 19.785,
    height: 10.642,
    transform: "translate(923.824 286.376)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 19.785,
    height: 10.642,
    transform: "translate(1203.594 286.376)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 13.448,
    height: 13.448,
    transform: "translate(1245.477 330.595)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M480.341,431.664a1.878,1.878,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445h.754a1.567,1.567,0,0,0,0-3.133h-.754Z",
    transform: "translate(448.089 -140.708)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M491.079,433.429c0,1.187-.649,1.946-1.667,1.946s-1.672-.76-1.672-1.946.654-1.947,1.672-1.947S491.079,432.242,491.079,433.429Zm-2.975,0c0,.992.506,1.624,1.308,1.624s1.309-.633,1.309-1.624-.512-1.625-1.309-1.625S488.1,432.437,488.1,433.429Z",
    transform: "translate(442.793 -140.594)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M500.445,433.429c0,1.187-.649,1.946-1.667,1.946s-1.672-.76-1.672-1.946.654-1.947,1.672-1.947S500.445,432.242,500.445,433.429Zm-2.975,0c0,.992.506,1.624,1.308,1.624s1.309-.633,1.309-1.624-.512-1.625-1.309-1.625S497.47,432.437,497.47,433.429Z",
    transform: "translate(436.954 -140.594)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M508.08,431.664c.886,0,1.287.375,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.044c-.163-.47-.348-.612-.765-.612h-.776v1.656h-.343v-3.756Zm-.76,1.789h.781c.639,0,.918-.338.913-.781,0-.475-.337-.7-.939-.7h-.754Z",
    transform: "translate(430.801 -140.708)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M1223.548,431.664a1.878,1.878,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445h.754a1.567,1.567,0,0,0,0-3.133h-.754Z",
    transform: "translate(-14.717 -140.708)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M1234.286,433.429c0,1.187-.649,1.946-1.667,1.946s-1.672-.76-1.672-1.946.655-1.947,1.672-1.947S1234.286,432.242,1234.286,433.429Zm-2.975,0c0,.992.506,1.624,1.308,1.624s1.308-.633,1.308-1.624-.512-1.625-1.308-1.625S1231.311,432.437,1231.311,433.429Z",
    transform: "translate(-20.013 -140.594)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M1243.653,433.429c0,1.187-.649,1.946-1.667,1.946s-1.673-.76-1.673-1.946.655-1.947,1.673-1.947S1243.653,432.242,1243.653,433.429Zm-2.976,0c0,.992.506,1.624,1.308,1.624s1.309-.633,1.309-1.624-.512-1.625-1.309-1.625S1240.677,432.437,1240.677,433.429Z",
    transform: "translate(-25.852 -140.594)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M1251.287,431.664c.886,0,1.287.375,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.044c-.163-.47-.348-.612-.765-.612h-.776v1.656h-.343v-3.756Zm-.76,1.789h.781c.638,0,.918-.338.912-.781,0-.475-.338-.7-.939-.7h-.754Z",
    transform: "translate(-32.006 -140.708)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M1325,548.977a1.879,1.879,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445H1325a1.567,1.567,0,0,0,0-3.134h-.754Z",
    transform: "translate(-77.891 -213.728)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M1335.736,550.742c0,1.187-.649,1.946-1.667,1.946s-1.673-.759-1.673-1.946.655-1.946,1.673-1.946S1335.736,549.555,1335.736,550.742Zm-2.976,0c0,.992.506,1.625,1.308,1.625s1.309-.633,1.309-1.625-.512-1.625-1.309-1.625S1332.76,549.751,1332.76,550.742Z",
    transform: "translate(-83.187 -213.615)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M1345.1,550.742c0,1.187-.649,1.946-1.667,1.946s-1.672-.759-1.672-1.946.654-1.946,1.672-1.946S1345.1,549.555,1345.1,550.742Zm-2.976,0c0,.992.507,1.625,1.308,1.625s1.309-.633,1.309-1.625-.512-1.625-1.309-1.625S1342.127,549.751,1342.127,550.742Z",
    transform: "translate(-89.025 -213.615)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M1352.737,548.977c.886,0,1.287.375,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.045c-.164-.47-.348-.612-.765-.612h-.776v1.657h-.343v-3.756Zm-.76,1.789h.781c.639,0,.918-.337.912-.781,0-.475-.338-.7-.939-.7h-.754Z",
    transform: "translate(-95.18 -213.728)",
    fill: "#b00927"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M471.7,404.132v1.419h1.825v.311H471.7v1.715h-.343v-3.756h2.284v.311Z",
    transform: "translate(453.023 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M481.859,405.585c0,1.188-.649,1.946-1.667,1.946s-1.672-.759-1.672-1.946.654-1.946,1.672-1.946S481.859,404.4,481.859,405.585Zm-2.976,0c0,.992.507,1.625,1.308,1.625s1.309-.633,1.309-1.625-.512-1.625-1.309-1.625S478.884,404.594,478.884,405.585Z",
    transform: "translate(448.556 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M490.543,403.821c.886,0,1.287.374,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.045c-.163-.469-.348-.612-.765-.612h-.775v1.657h-.343v-3.756Zm-.76,1.788h.781c.638,0,.918-.338.913-.78,0-.475-.338-.7-.939-.7h-.754Z",
    transform: "translate(441.748 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M499.9,407.577l-.422-1.715c-.142-.575-.285-1.15-.422-1.725h-.011c-.137.575-.28,1.15-.422,1.725l-.422,1.715h-.538l-.918-3.756h.348l.391,1.6c.153.612.3,1.224.448,1.836h.011c.153-.612.3-1.234.453-1.846l.391-1.588h.527l.391,1.588c.153.612.3,1.234.454,1.846h.011l.443-1.836.4-1.6h.348l-.918,3.756Z",
    transform: "translate(437.192 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M509.962,406.364l-.47,1.213h-.369l1.488-3.756h.47l1.482,3.756h-.369l-.469-1.213Zm1.488-.707c-.206-.533-.4-1.018-.6-1.557h-.01c-.206.539-.391,1.023-.6,1.557l-.153.39H511.6Z",
    transform: "translate(429.478 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M520.573,403.821c.886,0,1.287.374,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.045c-.163-.469-.348-.612-.765-.612h-.776v1.657h-.343v-3.756Zm-.76,1.788h.781c.638,0,.918-.338.913-.78,0-.475-.338-.7-.939-.7h-.754Z",
    transform: "translate(423.027 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M529.345,403.821a1.878,1.878,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445h.754a1.567,1.567,0,0,0,0-3.133h-.754Z",
    transform: "translate(417.556 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M543.811,404.963h-.359a1.045,1.045,0,0,0-1.1-1c-.775,0-1.25.617-1.25,1.625s.47,1.625,1.24,1.625a1.1,1.1,0,0,0,1.134-1.023h.359a1.409,1.409,0,0,1-1.493,1.345c-.992,0-1.6-.739-1.6-1.946s.618-1.946,1.615-1.946A1.357,1.357,0,0,1,543.811,404.963Z",
    transform: "translate(409.771 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M550.24,406.364l-.47,1.213H549.4l1.488-3.756h.47l1.482,3.756h-.369L552,406.364Zm1.488-.707c-.206-.533-.4-1.018-.6-1.557h-.01c-.206.539-.391,1.023-.6,1.557l-.153.39h1.514Z",
    transform: "translate(404.369 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M560.851,403.821c.886,0,1.287.374,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.045c-.163-.469-.348-.612-.764-.612h-.776v1.657h-.343v-3.756Zm-.76,1.788h.781c.639,0,.918-.338.913-.78,0-.475-.337-.7-.939-.7h-.754Z",
    transform: "translate(397.919 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M570.789,404.815h-.359a1,1,0,0,0-1.1-.855c-.807,0-1.3.622-1.3,1.635s.475,1.615,1.245,1.615c.655,0,1.182-.369,1.182-1.4h-1.1V405.5h1.435v1.963h-.322v-.575h-.011a1.322,1.322,0,0,1-1.218.638c-.96,0-1.572-.728-1.572-1.931s.633-1.957,1.662-1.957A1.32,1.32,0,0,1,570.789,404.815Z",
    transform: "translate(392.98 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M581.147,405.585c0,1.188-.649,1.946-1.667,1.946s-1.672-.759-1.672-1.946.654-1.946,1.672-1.946S581.147,404.4,581.147,405.585Zm-2.976,0c0,.992.507,1.625,1.308,1.625s1.309-.633,1.309-1.625-.512-1.625-1.309-1.625S578.172,404.594,578.172,405.585Z",
    transform: "translate(386.661 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M594.4,407.577v-1.793h-2.1v1.793h-.343v-3.756h.343v1.651h2.1v-1.651h.343v3.756Z",
    transform: "translate(377.847 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M604.737,405.585c0,1.188-.649,1.946-1.667,1.946s-1.673-.759-1.673-1.946.655-1.946,1.673-1.946S604.737,404.4,604.737,405.585Zm-2.976,0c0,.992.507,1.625,1.308,1.625s1.308-.633,1.308-1.625-.512-1.625-1.308-1.625S601.761,404.594,601.761,405.585Z",
    transform: "translate(371.956 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M614.65,407.266v.311h-2.332v-3.756h.343v3.445Z",
    transform: "translate(365.148 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M621.157,403.821a1.878,1.878,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445h.754a1.567,1.567,0,0,0,0-3.133H620.4Z",
    transform: "translate(360.322 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M1115.337,406.364l-.47,1.213h-.369l1.488-3.756h.47l1.482,3.756h-.37l-.469-1.213Zm1.488-.707c-.206-.533-.4-1.018-.6-1.557h-.01c-.206.539-.391,1.024-.6,1.557l-.153.39h1.514Z",
    transform: "translate(52.547 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M1125.188,404.132v1.419h1.826v.311h-1.826v1.715h-.343v-3.756h2.284v.311Z",
    transform: "translate(46.097 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M1133.48,404.132v3.445h-.343v-3.445H1131.8v-.311h3.017v.311Z",
    transform: "translate(41.76 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M1146.876,404.963h-.359a1.046,1.046,0,0,0-1.1-1c-.776,0-1.25.617-1.25,1.625s.47,1.625,1.24,1.625a1.1,1.1,0,0,0,1.134-1.023h.359a1.409,1.409,0,0,1-1.493,1.345c-.992,0-1.6-.739-1.6-1.946s.617-1.947,1.615-1.947A1.358,1.358,0,0,1,1146.876,404.963Z",
    transform: "translate(34.28 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M1153.3,406.364l-.47,1.213h-.369l1.488-3.756h.47l1.482,3.756h-.369l-.469-1.213Zm1.488-.707c-.206-.533-.4-1.018-.6-1.557h-.01c-.206.539-.391,1.024-.6,1.557l-.153.39h1.514Z",
    transform: "translate(28.879 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M1163.915,403.821c.886,0,1.287.375,1.287,1a.915.915,0,0,1-.728.944v.011c.279.084.4.243.559.7l.4,1.1h-.374l-.359-1.045c-.163-.47-.348-.612-.765-.612h-.776v1.657h-.343v-3.756Zm-.76,1.789h.781c.638,0,.918-.338.913-.781,0-.475-.338-.7-.939-.7h-.754Z",
    transform: "translate(22.428 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M1173.853,404.815h-.359a1,1,0,0,0-1.1-.854c-.807,0-1.3.622-1.3,1.635s.475,1.614,1.245,1.614c.654,0,1.182-.369,1.182-1.4h-1.1V405.5h1.435v1.963h-.322v-.575h-.01a1.322,1.322,0,0,1-1.219.638c-.96,0-1.572-.728-1.572-1.931s.634-1.957,1.662-1.957A1.32,1.32,0,0,1,1173.853,404.815Z",
    transform: "translate(17.49 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M1184.211,405.586c0,1.187-.648,1.946-1.667,1.946s-1.673-.759-1.673-1.946.654-1.947,1.673-1.947S1184.211,404.4,1184.211,405.586Zm-2.975,0c0,.992.506,1.625,1.308,1.625s1.308-.633,1.308-1.625-.512-1.625-1.308-1.625S1181.236,404.594,1181.236,405.586Z",
    transform: "translate(11.171 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M1197.461,407.577v-1.794h-2.1v1.794h-.343v-3.756h.343v1.651h2.1v-1.651h.343v3.756Z",
    transform: "translate(2.355 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M1207.8,405.586c0,1.187-.649,1.946-1.667,1.946s-1.672-.759-1.672-1.946.654-1.947,1.672-1.947S1207.8,404.4,1207.8,405.586Zm-2.975,0c0,.992.506,1.625,1.308,1.625s1.309-.633,1.309-1.625-.512-1.625-1.309-1.625S1204.826,404.594,1204.826,405.586Z",
    transform: "translate(-3.535 -123.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M1217.715,407.266v.311h-2.332v-3.756h.343v3.445Z",
    transform: "translate(-10.343 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M1224.221,403.821a1.879,1.879,0,1,1,0,3.756h-1.1v-3.756Zm-.754,3.445h.754a1.567,1.567,0,0,0,0-3.133h-.754Z",
    transform: "translate(-15.169 -123.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_43",
    "data-name": "Union 43",
    d: "M-15235.654-5059.627h0c-7.792-.438-23.143-4.016-42.075-8.028-15.739-3.338-32.559-10.105-37.808-12.305l-1.557-.7c-2.327-1.019-4.907-2.888-4.907-5.557s2.665-4.453,4.961-5.557c0,0,20.515-8.994,39.46-13.012,18.813-3.986,34.092-7.544,41.926-8.02v-.2h290.206v.377h-289.829V-5060h289.829v.377Z",
    transform: "translate(16130.555 5403.809)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M265.735,460.417,255.1,461.945s-.244.55.856,1.345,1.65,1.345,3.545.978,6.235-1.467,6.235-1.467Z",
    transform: "translate(587.595 -158.604)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M265.735,535.423,255.1,533.895s-.244-.55.856-1.345,1.65-1.344,3.545-.978,6.235,1.467,6.235,1.467Z",
    transform: "translate(587.595 -202.822)",
    fill: "#003d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M-15165.1-4910.068a5.429,5.429,0,0,1-4.6-2.68l-61.353-77.775,1.5-.289c-4.251.6-9.912,1.293-17.411,2.034-25.41,2.507-60.5,3.9-75.034,3.9v-.376c14.531,0,49.6-1.388,75-3.9,22.43-2.211,28.482-4.019,29.355-4.311v-36.208c-.873-.3-6.926-2.1-29.355-4.314-25.4-2.5-60.468-3.892-75-3.892v-.376c14.535,0,49.62,1.388,75.034,3.9,6.752.666,12.014,1.291,16.1,1.849l-.183-.034,61.353-77.775a5.429,5.429,0,0,1,4.6-2.68h9.413l-28.851,97.44h-.393a20.393,20.393,0,0,1,4.33,2.061,138.8,138.8,0,0,1,18.991,1.669h-.026a.042.042,0,0,0,.02,0h0c.415.084.719.346.719.658,0,.373-.446.68-.992.684-1.8.146-11.82.385-11.82.385l.026,0a64.872,64.872,0,0,1-6.921.008,19.739,19.739,0,0,1-4.118,1.98l29.031,98.048Z",
    transform: "translate(16507.104 5329.064)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M240.391,471.207s-7.063,11.585,0,22.594c0-.165,4.973-1.431,4.973-1.431s-5.133-9.578,0-19.892Z",
    transform: "translate(598.706 -165.298)",
    fill: "#003d64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB7879);
export default __webpack_public_path__ + "static/media/b787-9.a712a4ea5262a8a3a2268058b20afbcc.svg";
export { ForwardRef as ReactComponent };